import { forwardRef } from 'react'
import type { DraggableProps, DraggableProvided } from 'react-beautiful-dnd'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { formatDate } from '@domain-group/javascript-utils'

import EnabledPermission from '@components/EnabledPermission'

import useImage from '@hooks/useImage'

import type { CampaignModel, ImageModel } from '@models/types'

import { getCampaignType } from '@functions/campaign'
import ListItemImage from './ListItemImage'

interface ImageListItemProps {
  campaign: CampaignModel,
  dragHandleProps: DraggableProvided['dragHandleProps'],
  dragSnapshot: {
    isDragging: boolean,
  },
  draggableProps: DraggableProps,
  hasPublicImages: boolean,
  image: ImageModel,
  index: number,
}

const ImageListItem = forwardRef((props: ImageListItemProps, ref) => {
  const {
    campaign,
    dragHandleProps,
    dragSnapshot,
    draggableProps,
    hasPublicImages,
    image: initImage,
    index,
    ...restProps
  } = props

  const { isDragging } = dragSnapshot || {}

  const imagePayload = useImage(initImage)

  const {
    callbacks: { createOrEditImage },
    createdDate,
    image: { file_file_name },
    imageResolution: {
      height, width,
    },
  } = imagePayload

  const createdDateFormatted = formatDate(createdDate, 'dd/MM/yyyy HH:mm', "ccc, dd LLL yyyy 'at' h:mm a")

  return (
    <DashboardModuleListItem
      boxProps={{ backgroundColor: 'white' }}
      // @ts-expect-error TS2322
      forwardProps={{
        ...draggableProps,
        ...dragHandleProps,
      }}
      imageComponent={(
        <ListItemImage hasPublicImages={hasPublicImages} imagePayload={imagePayload} index={index} />
      )}
      isDragging={isDragging}
      ref={ref}
      secondaryText={`Created ${createdDateFormatted} - ${width}x${height}px`}
      showCheckbox
      title={file_file_name}
      {...restProps}
    >
      <EnabledPermission
        campaignType={getCampaignType(campaign)}
        permissionKey="campaign.media.manage"
      >
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            onClick={() => createOrEditImage()}
            type="edit"
          />
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      </EnabledPermission>
    </DashboardModuleListItem>
  )
})

export default ImageListItem
